function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcnSensoryxp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 143",
    d: "M12.7 18a5.63 5.63 0 1 0 5.62 5.62A5.63 5.63 0 0 0 12.7 18m0 12.2a6.58 6.58 0 1 1 6.57-6.58 6.58 6.58 0 0 1-6.57 6.58m0-3a.47.47 0 0 1-.48-.48V20.5a.48.48 0 1 1 .95 0v6.25a.47.47 0 0 1-.47.48m3.12-3.13H9.57a.5.5 0 1 1 0-1h6.25a.5.5 0 0 1 0 1m-5.72-6a10.16 10.16 0 0 1-.1-1.77A10.86 10.86 0 0 1 20.81 5.48a10.87 10.87 0 0 1 10.86 10.86V17c2 5.24 2.2 5.82 2.2 6a1.26 1.26 0 0 1-1.27 1.26h-1.67v1.69c0 2.26-1.6 3.83-4.28 4.2h-.15V34a.53.53 0 0 1-.53.53H12.69a.52.52 0 0 1-.53-.52v-4.26l1.05-.11v3.82h12.23v-3.82a.53.53 0 0 1 .53-.53c2.4 0 3.9-1.22 3.9-3.18v-2.22a.52.52 0 0 1 .53-.52h2.27l.16-.1v-.13c-.24-.72-1.44-3.87-2.15-5.68a.68.68 0 0 1 0-.19v-.74a9.81 9.81 0 0 0-9.8-9.8A9.83 9.83 0 0 0 11.15 18z",
    style: {
      fill: "#5e5e5d"
    }
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnSensoryxp);
export default __webpack_public_path__ + "static/media/icn-sensoryxp.4516e4000d86639b703a0ee9a6d0254f.svg";
export { ForwardRef as ReactComponent };